export default {
  filters: {
    toPrice(value) {
      value = value.toString();
      return value.replace('.', ',');
    },
    formatDate(date) {
      return date.split('-').reverse().join('/')
    }
  }
}
